import React, { useEffect, useState, useReducer, useRef } from 'react'


export default function JsonComponent({ updateVariableData, variableIdx, value, isEditing }) {

  const [json, setJson] = useState([{ 'input1': '', 'input2': '' }])
  const [presetJson, setPresetJson] = useState([])
  const [isEditingJson, setIsEditingJson] = useState(isEditing)

  useEffect(() => {
    updateVariableData(variableIdx, json)
  }, [json, isEditingJson])


  useEffect(() => {
    if (isEditingJson) {
      presetValue()
    }
  }, [value, isEditing])

  const presetValue = () => {
    if (value) {
      const keys = Object.keys(JSON.parse(value))
      let jsonObj = JSON.parse(value)
      let temp = [...presetJson]
      keys.map((key, idx) => {
        let Objkey = key
        let Objvalue = jsonObj[key]
        let objtopush = { 'input1': '', 'input2': '' }
        objtopush['input1'] = Objkey
        objtopush['input2'] = Objvalue
        temp.push(objtopush)

      })
      setPresetJson(temp)
      setJson(temp)
    }
  }


  return (
    <div>
      {
        isEditingJson && presetJson.map((obj, idx) => {
          return (
            <div className="d-flex">
              <input type="text" placeholder='key'
                value={presetJson[idx]['input1']}
                onChange={(e) => {
                  let temp = [...json];
                  temp[idx]['input1'] = e.target.value;
                  setIsEditingJson(false)
                  setJson(temp);

                }}
              ></input>
              <input type="text" placeholder='value'
                value={presetJson[idx]['input2']}
                onChange={(e) => {
                  let temp = [...json];
                  temp[idx]['input2'] = e.target.value;
                  setIsEditingJson(false)
                  setJson(temp);
                }}
              ></input>
            </div>
          )
        })
      }

      {
        !isEditingJson && json.map((data, id) => {
          return (
            <div className="d-flex">
              <input type="text" placeholder='key' value={json[id]['input1']} onChange={(e) => {
                let temp = [...json];
                temp[id]['input1'] = e.target.value;
                setJson(temp);

              }}></input>

              <input type="text" placeholder='value' value={json[id]['input2']}
                onChange={(e) => {
                  let temp = [...json];
                  temp[id]['input2'] = e.target.value;
                  setJson(temp);
                }}
              ></input>


            </div>
          )
        })
      }
      {
        <>
          <a onClick={() => {
            setIsEditingJson(false)
            let temp = [...json];
            temp.push({ 'input1': '', 'input2': '' })
            setJson(temp)

          }} className="plusIconText">
            <span className="icon-Group-272" />
          </a>
          <a
            onClick={() => {
              setIsEditingJson(false)
              let temp = [...json];
              if (json.length > 1) temp.pop()
              setJson(temp)
            }}
            className="minusBtn"
          >
            <span className="icon-Group-271"></span>
          </a>
        </>
      }



    </div>
  )
}
